module.exports = __webpack_public_path__ + "assets/images/promo3.jpg";